module.exports = __webpack_public_path__ + "img/Flag_of_Suriname.81e23bc3.svg";